<style lang="less" scoped>
  @import "../assets/colorTheme";
  .el-card{
    margin-bottom: 20px;
    height: 140px;
  }
  .img-item{
    padding: 3px;
    background-color: #e8e8e8;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      max-width: 100%;
      max-height: 100px;
      cursor: pointer;
    }
  }
  .result-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .time-tag{
      height:auto;
      width: 100%;
      font-size: 13px;
      color: @mainColor - #111;
      line-height: 18px;
      text-align: center;
      white-space: normal;
      border-radius: 5px;
    }
  }
  .result{
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 65px;
    margin-bottom: 5px;
    font-size: 16px;
    color: white;
    border-radius: 5px;
    background-color: #F56C6C + #2b2b2b;
    .mode{
      display: none;
    }
    .number{
      display: flex;
      flex-direction: column;
      font-size: 28px;
      width: 100%;
      border-bottom: 1px solid white;
      justify-content: flex-end;
    }
    .label{
      font-size: 14px;
      height: 20px;
    }
    &.SUCCESS{
      background-color: #67C23A + #0f0f0f;
    }
  }
</style>

<template>
  <el-card>
     
    <div style="text-align: center">

      <el-row :gutter="8" type="flex">
        <el-col :span="8" class="img-item">
          <img :src="src(data.image)" @click="openImg(data.image)"/>
        </el-col>
        <el-col :span="8" class="result-item">

          <div class="result" v-if="data.result.matchlist!==undefined" :class="data.compareResult">
            <div class="mode">
              {{data.route | route_name}}
            </div>
            <div class="mode">阈值{{data.threshold}} / 活体{{data.rgbLiveThreshold}}</div>
            <div class="mode">读取/对比帧 {{data.result.readframe}}/{{data.result.compareframe}}</div>
            <div class="number">{{data.compareResult==="SUCCESS"?"对比通过":"对比未通过"}}</div>
          </div>

          <div class="result fail" v-else>
            <div class="mode">
              {{data.route | route_name}}
            </div> 
            <div class="mode">阈值 {{data.threshold}}  活体 {{data.rgbLiveThreshold}}</div>
            <div class="content"> 
              {{data.result.msg}}
            </div>
          </div>
          
          <el-tag class="time-tag">{{data.createTime | date_time}}</el-tag>
        </el-col>

        <el-col :span="8" class="img-item">
          <video :src="videosrc(data.video)" controls width="100%" type="video/mp4">
            您的浏览器不支持 video 标签。
            Internet Explorer 9+, Firefox, Opera, Chrome 以及 Safari 支持 video 标签。
          </video>
        </el-col>
      </el-row>    
    
      <el-table :data="data.compareImagePairs">
        <el-table-column label="视频帧图片" align="center">
          <template v-slot="s">
            <el-image style="width: 100px; height: 100px"
                      :src="src(s.row.ImageName)"
                      @click="openImg(data.compareImagePairs[0].ImageName)"
                      fit="contain"></el-image> 
          </template>
        </el-table-column>
        <el-table-column :label="'置信度('+data.compareMode.replace('模式','')+')'" align="center">
          <template v-slot="s">
            {{(s.row.Match * 100).toFixed(2) + "%"}}
            <i v-if="s.row.Match >= data.threshold"
                class="el-icon-check" style="font-weight: bold; color:#00b900; font-size: 18px;"></i>
          </template>
        </el-table-column>
        <el-table-column label="对比信息" align="center">
          <template v-slot="s">
            {{s.row.ErrorMsg}}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="图片详情" :visible.sync="visible" append-to-body>
      <div style="text-align: center">
        <img :src="src(currentImg)" style="max-width: 100%" />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    data() {
      return {
        visible: false,
        currentImg: null
      }
    },
    methods: {
      src(key) {
        return this.$api.record.image1vsV({ id: this.data.id, key: key });
      },
      videosrc(key) {
        return this.$api.record.video1vsV({ id: this.data.id, key: key });
      },
      /*number(v){
        let result = JSON.parse(v.result);
        return Math.round(result.match / result.threshold * 100 * 100)/100;
      },*/
      openImg(img){
        this.visible = true;
        this.currentImg = img;
      }
    }
  }
</script>
